const { Box } = require("@mui/material");
const { styled } = require("@mui/system");

const FlexStart = styled(Box)({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
});

export default FlexStart;
